var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.228,
    height: 12.973,
    viewBox: "0 0 15.228 12.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: none;\r\n        stroke: #059881;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1498.278-1461.077l5.478,5.338,7.647-11.181",
    transform: "translate(1499.338 1467.962)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidicon);
export default __webpack_public_path__ + "static/media/valid.icon.647f1d0c66a579a72b2964b35d41896a.svg";
export { ForwardRef as ReactComponent };